import React, { useState, useEffect } from "react";

function AdhocPO({ supplier, purchaseOrderObject, setPurchaseOrderObject }) {
  const [rows, setRows] = useState([
    { id: Date.now(), item_description: "", qty: 0, cost: 0 }
  ]);

  useEffect(() => {
  if (!supplier) return;

  const validItems = rows.filter(
    (row) =>
      row.item_description.trim() !== "" &&
      row.qty > 0 &&
      row.cost > 0
  );

  setPurchaseOrderObject((prev) => {
    const next = { ...prev };

    if (validItems.length > 0) {
      next.adhoc[supplier.supplier_id] = {
        supplier,
        items: validItems,
      };
    } else {
      delete next.adhoc[supplier.supplier_id]; // remove if all rows are invalid/empty
    }

    return next;
  });
}, [rows, supplier, setPurchaseOrderObject]);

  const handleChange = (index, field, value) => {
    const updated = [...rows];
    updated[index][field] =
      field === "qty" || field === "cost" ? Number(value) : value;
    setRows(updated);
  };

  const addRow = () => {
    setRows([
      ...rows,
      { id: Date.now(), item_description: "", qty: 0, cost: 0 }
    ]);
  };

  const removeRow = (index) => {
    const updated = [...rows];
    updated.splice(index, 1);
    setRows(updated);
  };

  const totalLineCost = (qty, cost) => (qty * cost).toFixed(2);

  return (
    <div className="p-4 bg-[#F8F8F8] rounded-lg shadow">
      <table className="w-full text-sm text-gray-800 mb-4 border-collapse">
        <thead className="bg-gray-200 sticky top-0">
          <tr>
            <th className="text-left px-4 py-2 w-[40%]">Item Description</th>
            <th className="text-center px-4 py-2 w-[15%]">Qty</th>
            <th className="text-center px-4 py-2 w-[15%]">Cost</th>
            <th className="text-center px-4 py-2 w-[20%]">Line Cost</th>
            <th className="w-[10%] text-center px-4 py-2"></th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row, idx) => (
            <tr
              key={row.id}
              className="border-b hover:bg-white transition duration-150"
            >
              <td className="px-4 py-2">
                <input
                  type="text"
                  className="w-full p-2 border border-gray-300 rounded-md"
                  placeholder="Item description"
                  value={row.item_description}
                  onChange={(e) =>
                    handleChange(idx, "item_description", e.target.value)
                  }
                />
              </td>
              <td className="px-4 py-2 text-center">
                <input
                  type="number"
                  className="w-full p-2 border border-gray-300 rounded-md text-center"
                  value={row.qty}
                  onChange={(e) => handleChange(idx, "qty", e.target.value)}
                />
              </td>
              <td className="px-4 py-2 text-center">
                <input
                  type="number"
                  className="w-full p-2 border border-gray-300 rounded-md text-center"
                  value={row.cost}
                  onChange={(e) => handleChange(idx, "cost", e.target.value)}
                />
              </td>
              <td className="px-4 py-2 text-center">
                £ {totalLineCost(row.qty, row.cost)}
              </td>
              <td className="px-4 py-2 text-center">
                <button
                  onClick={() => removeRow(idx)}
                  className="text-red-600 hover:text-red-800 font-semibold"
                >
                  Remove
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className="text-right">
        <button
          onClick={addRow}
          className="bg-green-600 hover:bg-green-700 text-white px-6 py-2 rounded-lg text-sm"
        >
          + Add Line
        </button>
      </div>
    </div>
  );
}

export default AdhocPO;
